import {ofType, combineEpics} from 'redux-observable';
import {map, mergeMap} from 'rxjs/operators';

import chnlSvc from '../api/chnl/chnlService';
import {
  RDX_SESSION_INIT,
  updateSession,
  RDX_SESSION_INIT_DONE,
  initSessionDone,
} from '../redux/sessionAction';
import store from '../app/store';
import {valid} from '../api';
import {navigate} from '../redux/navAction';

const initSessionEpic = (action$) =>
  action$.pipe(
    ofType(RDX_SESSION_INIT),
    mergeMap(
      // @@WP-REACT: customize the init data step, it can be API or some logic
      // ...
      () =>
        chnlSvc.retrieveEnvParam().pipe(
          map((envResp) => {
            console.log('envResp', envResp);
            if (valid(envResp)) {
              const envData = {
                envParam: envResp.response.responseData,
              };
              store.dispatch(updateSession(envData));
              return initSessionDone();
            } else {
              return {type: 'rdx/Done'};
            }
          }),
        ),
    ),
  );

const initSessionDoneEpic = (action$, state$) =>
  action$.pipe(
    ofType(RDX_SESSION_INIT_DONE),
    map(() => {
      console.log('Start navigate to', state$.value.session.targetFunc, state$);
      return navigate(state$.value.session.targetFunc);
    }),
  );

export default combineEpics(initSessionEpic, initSessionDoneEpic);
